<template>
  <div class="ticker-wrapper">
    <div class="ticker-container">
      <div class="ticker-content" ref="tickerContent">
        <div class="item" v-for="v in doubleList" :key="v.id" @click="router.push('/oneStocks?id='+v.id)">
          <!-- <div class="item" v-for="v in doubleList" :key="v.id"> -->
          <div class="symbol-title">{{ v.name }}</div>
          <div class="center">
            <p class="val" :class="{red:v.profit_and_Loss>=0}">{{ Number(v.price).toFixed(2) }}</p>
            <p class="p2" :class="{red:v.profit_and_Loss>=0}">
              <span><span v-if="v.profit_and_Loss>=0">+</span>{{ Number(v.profit_and_Loss).toFixed(2) }}</span>
              <span>{{ Number(v.increase).toFixed(2) }}%</span>
            </p>
          </div>
          <div class="echarts">
            <MiniChart :data="v.history" :color="v.profit_and_Loss >= 0 ? '#009465' : '#B40000'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="RollingIndexPage">
import { useRouter } from "vue-router";
import { formatNumber } from "@/utils/globalMethods"
import { ref, onMounted, computed } from "vue";
const router = useRouter()

const props = defineProps({
  list: { type: Array, default: () => [] },
});

// ⭐ 生成两份数据用于无缝滚动
const doubleList = computed(() => {
  return props.list
    .map((v, i) => ({ ...v, uid: `a-${i}` }))
    .concat(props.list.map((v, i) => ({ ...v, uid: `b-${i}` })));
});

const tickerContent = ref(null);
let animationId = null;

onMounted(() => {
  const content = tickerContent.value;
  if (!content) return;

  let pos = 0;
  const speed = 0.5; // 滚动速度

  const animate = () => {
    pos -= speed;

    // 实际滚动范围 = 一半内容的宽度（因为 doubleList）
    const halfWidth = content.scrollWidth / 2;

    if (Math.abs(pos) >= halfWidth) {
      pos = 0; // 重置
    }

    content.style.transform = `translateX(${pos}px)`;

    animationId = requestAnimationFrame(animate);
  };

  animate();
});
</script>

<style scoped lang="scss">
.ticker-wrapper {
  overflow: hidden;
  padding: 8px 0;
  width: calc(100% - 30px);
  // margin-top: 15px;
  margin-left: 15px;
}

.ticker-container {
  width: 100%;
  overflow: hidden;
}

.ticker-content {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  will-change: transform;
}

/* 单个 item 样式 */
.item {
  flex-shrink: 0;
  width: 130px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  padding: 12px 8px;
  flex-direction: column;
  gap: 5px;
  margin-right: 8px;

  .symbol-title {
    font-size: 14px;
    font-weight: 400;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 限制两行 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    // word-break: break-word;
    white-space: normal;
  }


  .center {
    display: flex;
    flex-direction: column;
    gap: 3px;

    .val {
      color: #B40000;
      font-size: 16px;
      font-weight: 700;
    }

    .p2 {
      color: #B40000;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
    }
    .red{
      color: #009465;
    }
  }

  .echarts {
    width: 100%;
    height: 45px;
  }
}
</style>
